"use client";

import { TabItem } from "@/app/utilities/interfaces";
import React, { useState } from "react";


interface TabsProps {
  items: TabItem[];
  sidebarTabs?: string;
  tabspadding?:string;
}

const Tabs: React.FC<TabsProps> = ({ items, sidebarTabs,tabspadding }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <div className="flex gap-2 overflow-x-auto whitespace-nowrap md:flex-nowrap md:whitespace-normal border-b border-gray-200 scrollbar-hide">
        {items.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`pr-4 py-2 font-medium text-[14px] ${tabspadding} ${sidebarTabs ?? ""} ${
              activeIndex === index
                ? "border-b-2 border-[text-automotive-red] text-[#008c8b]"
                : "text-gray-500 hover:text-black"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-4">{items[activeIndex].content}</div>
    </>
  );
};

export default Tabs;
